























































import Vue from 'vue';
import cloneDeep from 'lodash/cloneDeep';
import Const, { DIFFICULTY_LEVEL } from '@/classes/const';
import SaveData from '@/classes/saveData/saveData';
import SiteSetting from '@/classes/siteSetting';
import {
  addDoc, collection, getFirestore, serverTimestamp,
} from 'firebase/firestore/lite';
import LZString from 'lz-string';
import { MasterMap, MasterWorld } from '@/classes/interfaces/master';

export default Vue.extend({
  name: 'UploadSaveData',
  props: {
    saveData: {
      type: SaveData,
      required: true,
    },
    dataName: {
      type: String,
      required: true,
    },
    dataRemarks: {
      type: String,
      required: true,
    },
    cancelDialog: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    areaItems: [] as ({ divider: boolean } | { header: string } | { value: number; text: string; group: string })[],
    area: 11,
    editedName: '',
    editedRemarks: '',
    level: DIFFICULTY_LEVEL.HARD,
    levelItems: Const.DIFFICULTY_LEVELS,
    uploadUserName: '',
    uploadConfirmDialog: false,
    uploadClicked: false,
    nameRules: [(v: string) => !!v || '編成名は必須です。', (v: string) => v.length <= 100 || '1～100文字以内で入力してください。'],
    remarksRules: [(v: string) => !!v || '補足情報は必須です。'],
    userNameRules: [(v: string) => v.length <= 20 || '0～20文字以内で入力してください。'],
  }),
  mounted() {
    // 海域セレクトボックス初期化
    if (!this.areaItems.length) {
      const items = [];
      const worlds = this.$store.state.worlds as MasterWorld[];
      const masterMaps = this.$store.state.maps as MasterMap[];
      for (let i = 0; i < worlds.length; i += 1) {
        const world = worlds[i];
        const maps = masterMaps.filter((v) => Math.floor(v.area / 10) === world.world);
        if (!maps.length) {
          continue;
        }
        if (i > 0) {
          items.push({ divider: true });
        }

        items.push({ header: world.name });
        for (let j = 0; j < maps.length; j += 1) {
          const map = maps[j];
          const { area } = map;
          const mapName = map.name;
          const worldText = world.world > 40 ? 'E' : `${world.world}`;
          items.push({ value: area, text: `${worldText}-${area % 10} : ${mapName}`, group: world.name });
        }
      }
      this.areaItems = items;
    }
    const setting = this.$store.state.siteSetting as SiteSetting;
    this.uploadUserName = setting.userName;

    this.initControl();
  },
  computed: {
    isEvent(): boolean {
      return Math.floor(this.area / 10) > 40;
    },
  },
  methods: {
    initControl() {
      this.editedName = this.dataName;
      this.editedRemarks = this.dataRemarks;
      // 現在計算画面で開かれているデータを取得
      const data = this.saveData.getMainData();
      if (data && data.tempData[data.tempIndex]) {
        const manager = data.tempData[data.tempIndex];
        const lastEnemyArea = manager.battleInfo.fleets[manager.battleInfo.fleets.length - 1].area;
        // 最終戦闘マスのareaがあればそれを初期値とする
        if (lastEnemyArea) {
          this.area = lastEnemyArea;
        }
      }
    },
    validateUpload() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const valid = (this.$refs.uploadForm as any).validate() as boolean;
      if (valid) {
        this.uploadConfirmDialog = true;
        this.uploadClicked = false;
      }
    },
    async uploadSaveData() {
      this.uploadClicked = true;
      const data = this.saveData.getMainData();
      if (data) {
        try {
          const tempSaveData = new SaveData();
          tempSaveData.tempData = [cloneDeep(data.tempData[data.tempIndex])];
          tempSaveData.tempIndex = 0;
          tempSaveData.saveManagerData();

          const newPreset = {
            id: tempSaveData.id,
            name: this.editedName,
            data: LZString.compressToBase64(tempSaveData.manager),
            memo: this.editedRemarks,
            createdAt: serverTimestamp(),
            map: this.area,
            level: this.area > 400 ? 4 - this.level : 0,
            user: this.uploadUserName ? this.uploadUserName : '',
            ver: 2,
          };
          const db = getFirestore();
          await addDoc(collection(db, 'presets'), newPreset);
          this.$emit('inform', 'アップロードが完了しました。');

          if (this.uploadUserName) {
            // 投稿者名があれば次回使うように保存
            const setting = this.$store.state.siteSetting as SiteSetting;
            setting.userName = this.uploadUserName;
            this.$store.dispatch('updateSetting', setting);
          }
        } catch (error) {
          console.error(error);
          this.$emit('inform', 'アップロードに失敗しました。', true);
        }
      }
      this.uploadConfirmDialog = false;
    },
  },
});
